import { motion } from "framer-motion";
import { useContext, useEffect, useState } from "react";
import { VisualAudioContext } from ".";

export const AudioVisualizerNxtx = ({ customClass }) => {
  const [volumes, setVolumes] = useState<number[]>(Array(10).fill(0));
  const [audioContext, setAudioContext] = useState<AudioContext | null>(null);
  const [analyser, setAnalyser] = useState<AnalyserNode | null>(null);
  const [dataArray, setDataArray] = useState<Uint8Array | null>(null);
  const isMuted = useContext(VisualAudioContext);

  useEffect(() => {
    const initAudio = async () => {
      try {
        const stream = await navigator.mediaDevices.getUserMedia({
          audio: true,
        });
        const audioCtx = new window.AudioContext();
        const analyserNode = audioCtx.createAnalyser();
        const source = audioCtx.createMediaStreamSource(stream);
        source.connect(analyserNode);
        analyserNode.fftSize = 256;
        const bufferLength = analyserNode.frequencyBinCount;
        const dataArray = new Uint8Array(bufferLength);

        setAudioContext(audioCtx);
        setAnalyser(analyserNode);
        setDataArray(dataArray);
      } catch (err) {
        console.error("Error accessing microphone", err);
      }
    };

    if (!isMuted) {
      initAudio();
    } else if (audioContext) {
      audioContext.close();
      setAudioContext(null);
    }

    return () => {
      if (audioContext) {
        audioContext.close();
      }
    };
  }, [isMuted]);

  useEffect(() => {
    if (analyser && dataArray && !isMuted) {
      const updateBars = () => {
        analyser.getByteFrequencyData(dataArray);
        setVolumes(Array.from(dataArray).slice(0, 10));
        requestAnimationFrame(updateBars);
      };
      updateBars();
    } else if (isMuted) {
      // Set bars to zero when muted
      const updateBars = () => {
        setVolumes(Array(10).fill(0));
        requestAnimationFrame(updateBars);
      };
      updateBars();
    }
  }, [analyser, dataArray, isMuted]);

  return (
    <motion.div className={customClass}>
      <motion.div className="flex space-x-1 gap-4">
        {volumes.map((volume, index) => (
          <motion.div
            key={index}
            className="w-4 max-h-8 bg-black_to_black rounded-md"
            style={{ height: `${Math.max(volume, 10)}px` }}
            animate={{ scaleY: 1 + volume / 50 }}
            transition={{
              type: "spring",
              stiffness: 300,
              damping: 15,
            }}
          />
        ))}
      </motion.div>
    </motion.div>
  );
};
